{
  "validation.required": "{{label}} ist ein Pflichtfeld",
  "validation.minLength": "{{label}} muss mindestens {{min}} Zeichen lang sein",
  "validation.maxLength": "{{label}} darf nicht länger als {{max}} Zeichen sein",
  "validation.contentTypeAlphanumeric": "{{label}} muss alphanumerisch sein",
  "validation.contentTypeDate": "{{label}} muss ein Datum sein",
  "validation.contentTypeDateBefore": "{{label}} muss ein Datum vor {{date beforeDate}} sein",
  "validation.contentTypeDateAfter": "{{label}} muss ein Datum nach {{date afterDate}} sein",
  "validation.contentTypeDatetime": "{{label}} muss ein Datum und eine Uhrzeit sein",
  "validation.contentTypeDatetimeBefore": "{{label}} muss ein Datum vor {{datetime beforeDate}} sein",
  "validation.contentTypeDatetimeAfter": "{{label}} muss ein Datum nach {{datetime afterDate}} sein",
  "validation.contentTypeEmail": "{{label}} muss eine E-Mail sein",
  "validation.contentTypeInteger": "{{label}} muss eine Zahl sein",
  "validation.contentTypeNumber": "{{label}} muss eine Zahl sein",
  "validation.contentTypeRegex": "{{label}} hat das falsche Format",
  "validation.contentTypeText": "{{label}} muss ein Text sein",
  "validation.contentTypeTime": "{{label}} muss eine Zeit sein",
  "validation.contentTypeUrl": "{{label}} muss eine Webadresse sein",
  "select-element.default-option": "Wählen…",
  "button-element.network-required": "Sie sind derzeit offline. Bitte stellen Sie eine Netzwerkverbindung her, um fortzufahren."
}